/* LevelUp · Gym wholesale landing page. Profit calculator, floating CTA, mobile menu. No dependencies. */
(function () {
  'use strict';
  var $ = function (id) { return document.getElementById(id); };
  var money = function (n, dp) { return '$' + n.toLocaleString('en-US', { minimumFractionDigits: dp, maximumFractionDigits: dp }); };
  var hdr = document.querySelector('.gw-top'), offer = document.querySelector('.gw-bar'), nav = document.querySelector('.gw-nav');

  // ---- Mobile: the offer bar scrolls away, only the nav stays pinned (height measured, not hard-coded)
  var setBarH = function () { if (hdr && offer) hdr.style.setProperty('--barh', offer.offsetHeight + 'px'); };
  setBarH(); window.addEventListener('resize', setBarH);

  // ---- Mobile menu: close on link tap, outside tap and Escape
  var menu = document.querySelector('.gw-menu');
  if (menu) {
    menu.addEventListener('click', function (e) { if (e.target.closest('.gw-menu__panel a')) menu.open = false; });
    document.addEventListener('click', function (e) { if (menu.open && !menu.contains(e.target)) menu.open = false; });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && menu.open) { menu.open = false; menu.querySelector('summary').focus(); } });
  }

  // ---- Profit calculator
  var calc = document.querySelector('.gw-calc');
  if (calc) {
    var ws = parseFloat(calc.getAttribute('data-ws')) || 22;
    var m = $('gw-members'), r = $('gw-rate'), p = $('gw-price'), yr = document.querySelector('.gw-calc__yr'), sr = $('gw-calc-sr'), srT;
    var fill = function (el) { el.style.setProperty('--p', ((el.value - el.min) / (el.max - el.min) * 100) + '%'); };
    var update = function () {
      var members = +m.value, rate = +r.value, price = +p.value;
      var tubs = Math.floor(members * rate / 100);           // round down: a profit illustration should never overstate
      var perMonth = tubs * (price - ws), perYear = Math.round(perMonth * 12);
      $('gw-members-o').textContent = members;
      $('gw-rate-o').textContent = rate + '%';
      $('gw-price-o').textContent = money(price, 2);
      $('gw-tubs').textContent = tubs;
      $('gw-pm').textContent = money(perMonth, 2);
      $('gw-yr').textContent = money(perYear, 0);
      if (yr) yr.classList.toggle('is-long', perYear >= 100000);
      var n = 100 / rate;
      var who = (n % 1 === 0 && n <= members) ? '1 in ' + n + ' members buys' : rate + '% of members buy';
      $('gw-yr-note').textContent = tubs === 0
        ? 'At this rate your box sells less than a tub a month. Try more members or a higher rate.'
        : 'in profit from one shelf, when ' + who + ' a tub a month.';
      p.setAttribute('aria-valuetext', money(price, 2)); r.setAttribute('aria-valuetext', rate + ' percent');
      [m, r, p].forEach(fill);
      if (sr) { clearTimeout(srT); srT = setTimeout(function () { sr.textContent = tubs + ' tubs a month, ' + money(perMonth, 2) + ' profit a month, ' + money(perYear, 0) + ' a year.'; }, 400); }
    };
    [m, r, p].forEach(function (el) { el.addEventListener('input', update); });
    update();
  }

  // ---- Floating CTA: shows once the hero's Buy button has scrolled under the pinned header,
  //      hides while any other in-page Buy button is at least 40% on screen.
  var bar = $('gw-float'), hero = $('hero');
  if (bar && hero && 'IntersectionObserver' in window) {
    var heroCta = hero.querySelector('.gw-cta') || hero, heroGone = false, ctasVisible = new Set();
    var render = function () {
      var on = heroGone && ctasVisible.size === 0;
      bar.classList.toggle('is-on', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      var a = bar.querySelector('a'); if (a) a.tabIndex = on ? 0 : -1;
    };
    var pinned = matchMedia('(min-width:900px)').matches ? (hdr ? hdr.offsetHeight : 0) : (nav ? nav.offsetHeight : 0);
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { heroGone = !e.isIntersecting && e.boundingClientRect.top < (e.rootBounds ? e.rootBounds.top : 0); });
      render();
    }, { rootMargin: '-' + pinned + 'px 0px 0px 0px' }).observe(heroCta);
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting && e.intersectionRatio >= 0.4) ctasVisible.add(e.target); else ctasVisible.delete(e.target); });
      render();
    }, { threshold: [0, 0.4] });
    document.querySelectorAll('.gw-cta').forEach(function (el) { if (!hero.contains(el)) io.observe(el); });
  }
})();
